import { render, staticRenderFns } from "./VideoPostCreator.vue?vue&type=template&id=4d297416&scoped=true&"
import script from "./VideoPostCreator.vue?vue&type=script&lang=js&"
export * from "./VideoPostCreator.vue?vue&type=script&lang=js&"
import style0 from "./VideoPostCreator.vue?vue&type=style&index=0&id=4d297416&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d297416",
  null
  
)

export default component.exports